var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-wrapper"},[_c('div',{staticClass:"viewport"},[_c('sart-test',{attrs:{"parameters":_vm.parameters},on:{"end":_vm.onEnd}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }